import { useEffect, RefObject } from 'react';
import { DOCUMENT_ACTIVITY_ITEM_BUTTON_NAME } from '../components/document-wizard/document-editor/components/documentActivitySidebar/components/constants';
import { SIGNER_ITEM_BUTTON_NAME } from '../components/document-wizard/document-editor/components/signersSidebar/components/signerItem/constants';

/**
 * Detect click-off events and escape key presses. Useful for triggering close behaviour on navs and popouts.
 *
 * @function useOnClickOff
 * @param {Ref} containerRef - The container within which clicks will not trigger 'onClickOff'
 * @param {CallableFunction} onClickOff - The function that will be triggered when a click off or escape key press is detected.
 * @returns {null}
 */
export default function useOnClickOff(containerRef: RefObject<HTMLElement>, onClickOff: () => void): void {
  useEffect(() => {
    const onClick = (e: MouseEvent) => {
      const activeModal = document.getElementsByClassName('fade modal');

      if (!!activeModal[0] && activeModal[0].contains(e.target as Node)) {
        return;
      }

      const isSignerButton = (e as any).path?.find(
        (node: any) => node.name === SIGNER_ITEM_BUTTON_NAME || node.name === DOCUMENT_ACTIVITY_ITEM_BUTTON_NAME
      );

      if (
        (containerRef.current && containerRef.current.compareDocumentPosition(e.target as Node) >= 20) ||
        (e.target as any).href ||
        !!isSignerButton
      )
        return;
      onClickOff();
    };
    const onKeyup = (e: KeyboardEvent) => {
      // escape
      if (e.keyCode === 27) onClickOff();
    };
    document.addEventListener('click', onClick);
    document.addEventListener('keyup', onKeyup);

    return function cleanup() {
      document.removeEventListener('click', onClick);
      document.removeEventListener('keyup', onKeyup);
    };
  });
}
